module.exports = __webpack_public_path__ + "static/home1-mega-menu-315ea5bc8bfd4203f54e68f8b670a23a.jpg";